import React from 'react';
import { Space, Button } from 'antd';
import PreviewModal from '../../formPreview/PreviewModal';
import SaveDraftContract from '../../draftContract/SaveDraftContract';
import PropTypes from 'prop-types';

const CreateContractFooter = ({ steps, activeStep, handleBack }) => {

  return (
    <div className="buttons-container justify-content-center">
      <Space>
        {(activeStep > 0) && (
          <Button size="large" onClick={handleBack}>
            Volver
          </Button>
        )}
        {[...Array(3).keys()].includes(activeStep) && (
          <>
            <SaveDraftContract />
            <PreviewModal />
          </>
        )}
        {(activeStep < steps.length - 1) && (
          <Button size="large" type="primary" htmlType="submit">
            Continuar
          </Button>
        )}
      </Space>
    </div>
  );
};

CreateContractFooter.propTypes = {
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
};

export default CreateContractFooter;